export const environment = {
  production: false,

  firebase: {
    apiKey: "AIzaSyADFVBJ_C5yaBa2O8viqmMKgGl3R13Fz7c",
    authDomain: "apkactiviteit-c2798.firebaseapp.com",
    projectId: "apkactiviteit-c2798",
    storageBucket: "apkactiviteit-c2798.firebasestorage.app",
    messagingSenderId: "436410172480",
    appId: "1:436410172480:web:e1af823ab0e008f0a3cba5"
  }
};
